module.exports = __webpack_public_path__ + "static/media/TPT Approval Data - Sample.2679dd71.csv";